import React from 'react';
import { injectIntl, FormattedMessage, FormattedPlural } from 'react-intl';
import { colorToArray, i18nIntl, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';

import AnimatedTotalCountIcon from '../front/buttons/AnimatedTotalCountIcon';

const Wrapper = (props) => {
	return (
		<div class="game_ctas">
			{props.children}
		</div>
	)
};

const NextActionButton = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;

	if(is_builder) {
		return (
			<Wrapper />
		)
	}

	const status = props?.status ?? 'ko';
	const retries = props?.retries ?? false;
	const allow_retry = props?.allow_retry ?? false;
	const allow_ranking = props?.allow_ranking ?? false;
	const disallow_complete = props?.disallow_complete ?? false;
	const is_multiparticipation = props?.multiparticipation ?? false;
	const button_text_color = props?.button_text_color ?? false;
	const prize = props?.prize ?? false;
	const next_participation = props?.next_participation ?? false;
	const _custom_color = props?.custom_color ?? false;
	const override_promo_styles = props?.override_promo_styles ?? false;
	const type = props?.type ?? 'button';

	const ko_with_participations = status == 'ko' && retries > 0;

	let main_action = props?.main_action ?? 'continue';
	if(is_multiparticipation && retries < 1) main_action = 'finalize';
	if(is_multiparticipation && retries >= 1) main_action = 'try_again';
	if(is_multiparticipation && prize !== false) main_action = 'with_prize';

	const display_next_participations = (is_multiparticipation && next_participation !== false && main_action == 'finalize') ? true : false;
	const display_counter_icon = (is_multiparticipation && (main_action != 'continue' && main_action != 'with_prize')) ? true : false;

	let action = null;
	let button_label = "Continue";
	let show_continue = true;
	let small_button_label = "Finalize";
	let small_action = props?.continueGame ?? null;
	let allow_finalize = false;
	let extra_label = false;

	switch(main_action) {
		case 'continue':
			action = props.continueGame;
			if(!is_multiparticipation && status != 'ok' && disallow_complete) show_continue = false;
			break;

		case 'with_prize':
			action = props.continueGame;
			//button_label = "You've won a prize";
			extra_label = "You've won a prize";
			break;

		case 'finalize':
			action = props.continueGame;
			button_label = "Finalize";
			break;

		case 'try_again':
			action = props.restartGame;
			allow_finalize = (true && !disallow_complete) ? true : false;
			button_label = "Try again";
			break;
	}

	if(props.login_type != undefined && props.login_type == 4 && status == 'ok') {
		if(main_action == 'try_again') {
			button_label = "Continue";
			small_button_label = "Try again";
			small_action = props.restartGame;
			action = props.continueGame;
		}
	}

	let button_styles = null;
	if(button_text_color !== false && type == 'button') {
		const button_color = colorToArray(button_text_color);
		const button_color_light = isColorBright(RGB_2_HEX(button_text_color));

		if(override_promo_styles === false) {
			button_styles = {
				'--button-background-color':(button_color_light) ? '0, 0, 0, 1' : '255, 255, 255, 1',
				'--button-background-color-hover':(button_color_light) ? '0, 0, 0, 0.8' : '255, 255, 255, 0.8',
				'--link-color':`${button_color}, 1`,
				'--button-text-color-hover':`${button_color}, 1`,
			};
		}
	}

	let custom_styles = null;
	if(_custom_color !== false && type == 'button') {
		const custom_color = colorToArray(_custom_color);

		if(override_promo_styles === false) {
			custom_styles = {
				'--link-color':`${custom_color}, 1`,
				'--link-color-hover':`${custom_color}, 0.8`,
			}
		}
	}

	const MainComponent = (type == 'button') ? ActionButton : ActionLink;

	const main_item_classes = ['gui_flex_center'];
	if(type == 'button') {
		if(override_promo_styles === false) main_item_classes.push('gui_custom_color');
		main_item_classes.push('flex_button gui_big_button gui_not_in_bottom_small');
	}

	const extra_links_classes = ['gui_not_in_top_small'];
	if(type == 'button' && override_promo_styles === false) extra_links_classes.push('whiteColor');

	return (
		<Wrapper>
			{(show_continue) && (
				<div class={main_item_classes.join(" ")} style={button_styles}>
					<MainComponent
						onClick={() => action()}
						_fullclass="original_color_item"
						style={custom_styles}
					>{button_label}</MainComponent>
				</div>
			)}

			{(extra_label !== false && extra_label != "") && (
				<p class='has_prize'>{i18n(extra_label)}</p>
			)}

			{(display_counter_icon && retries > 0 && retries < 11) && (
				<p class="participations_left">
					<FormattedMessage
						id="You still have {counter} left"
						values={{counter:<span class="left_participation_count">
							<AnimatedTotalCountIcon
								count_number={retries}
							/> <FormattedPlural value={retries} one={i18n("participation")} other={i18n("participations")} />
						</span>}}
					/>
				</p>
			)}

			{(display_next_participations) && (
				<p>
					<FormattedMessage
						id="Try again {time}"
						values={{ time:next_participation }}
					/>
				</p>
			)}

			{(allow_retry && !is_multiparticipation) && (
				<p>
					<ActionLink
						onClick={() => props.restartGame()}
						_class={{ other:extra_links_classes.join(" ") }}
					>Try again</ActionLink>
				</p>
			)}

			{(is_multiparticipation && allow_finalize) && (
				<p>
					<ActionLink
						onClick={small_action}
						_class={{ other:extra_links_classes.join(" ") }}
					>{small_button_label}</ActionLink>
				</p>
			)}

			{(allow_ranking) && (
				<p>
					<ActionLink
						_href={`/entries/${props.promotion_id}`}
						_class={{ other:extra_links_classes.join(" ") }}
					>Ranking</ActionLink>
				</p>
			)}
		</Wrapper>
	)
}

export default injectIntl(NextActionButton);